import type { ComponentMetaInput } from './meta';
import type { ImageCropKind } from './imageCrop';

const PARTS = {
  overlay: { label: '图片裁剪遮罩', role: 'container', layout: { x: 0, y: 0, width: 390, height: 844 } },
  dialog: { label: '图片裁剪弹窗', role: 'container', layout: { x: 12, y: 70, width: 366, height: 704 } },
  title: { label: '裁剪标题', role: 'text', layout: { x: 28, y: 86, width: 260, height: 28 } },
  close: { label: '取消裁剪', role: 'button', layout: { x: 322, y: 80, width: 40, height: 40 } },
  ratio: { label: '竖屏比例', role: 'input', layout: { x: 112, y: 132, width: 250, height: 40 } },
  customRatio: { label: '自定义竖屏比例', role: 'input', layout: { x: 28, y: 190, width: 334, height: 48 } },
  viewport: { label: '图片裁剪区域', role: 'container', layout: { x: 28, y: 250, width: 334, height: 340 } },
  zoom: { label: '裁剪缩放', role: 'input', layout: { x: 28, y: 604, width: 334, height: 48 } },
  error: { label: '裁剪错误提示', role: 'text', layout: { x: 28, y: 662, width: 334, height: 40 } },
  reset: { label: '重置裁剪', role: 'button', layout: { x: 28, y: 718, width: 40, height: 40 } },
  cancel: { label: '取消', role: 'button', layout: { x: 176, y: 718, width: 64, height: 40 } },
  confirm: { label: '应用裁剪', role: 'button', layout: { x: 252, y: 718, width: 110, height: 40 } },
} satisfies Record<string, Omit<ComponentMetaInput, 'id' | 'page'>>;

export function imageCropMeta(kind: ImageCropKind, part: keyof typeof PARTS): ComponentMetaInput {
  return {
    ...PARTS[part],
    id: `imageCrop.${kind}.${part}`,
    page: kind === 'avatar' ? 'presets' : 'settings',
    zIndex: 20000,
    notes: kind === 'avatar'
      ? '圆形裁剪，正方形 PNG 内切圆恰好填满头像；原生对应圆形裁剪蒙层。弹层随可用高度滚动。'
      : '竖屏背景裁剪，支持常见手机比例及 9:12 至 9:24 连续自定义。弹层随可用高度滚动。',
  };
}

export const IMAGE_CROP_COMPONENTS: ComponentMetaInput[] = (['wallpaper', 'avatar'] as const).flatMap((kind) =>
  (Object.keys(PARTS) as (keyof typeof PARTS)[])
    .filter((part) => kind !== 'avatar' || (part !== 'ratio' && part !== 'customRatio'))
    .map((part) => imageCropMeta(kind, part)),
);
